import { buildApi } from '../util/api.util';

export const permissionsapi = buildApi(
  process.env.REACT_APP_PERMISSIONS_API_URL!,
);
